import { useState, useCallback } from 'react';
import { apiFetch } from '../api';

function LockScreen({ onUnlock }) {
  const [pin, setPin] = useState('');
  const [error, setError] = useState(false);
  const [checking, setChecking] = useState(false);

  const verifyPin = useCallback(async (code) => {
    setChecking(true);
    setError(false);
    try {
      const res = await apiFetch('/api/auth/unlock', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ pin: code }),
      });

      if (res.ok) {
        sessionStorage.removeItem('meware_locked');
        onUnlock();
      } else {
        setError(true);
        setPin('');
      }
    } catch {
      setError(true);
      setPin('');
    } finally {
      setChecking(false);
    }
  }, [onUnlock]);

  function handleKey(digit) {
    if (checking) return;
    setError(false);
    const newPin = pin + digit;
    setPin(newPin);
    if (newPin.length === 4) {
      verifyPin(newPin);
    }
  }

  function handleBackspace() {
    setError(false);
    setPin(pin.slice(0, -1));
  }

  return (
    <div className="lock-screen">
      <div className="lock-content">
        <div className="lock-icon">&#x1F512;</div>
        <div className="lock-dots">
          {[0, 1, 2, 3].map((i) => (
            <div
              key={i}
              className={`lock-dot${i < pin.length ? ' filled' : ''}${error ? ' error' : ''}`}
            />
          ))}
        </div>
        {error && <div className="lock-error">Incorrect PIN</div>}
        {checking && <div className="lock-checking">Checking...</div>}
        <div className="lock-keypad">
          {[1, 2, 3, 4, 5, 6, 7, 8, 9, null, 0, 'del'].map((key, i) => {
            if (key === null) return <div key={i} className="lock-key-spacer" />;
            if (key === 'del') {
              return (
                <button key={i} className="lock-key lock-key-del" onClick={handleBackspace}>
                  &#x232B;
                </button>
              );
            }
            return (
              <button key={i} className="lock-key" onClick={() => handleKey(String(key))}>
                {key}
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}

export default LockScreen;
